import React from "react";

const UploadIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx="32" cy="32" r="32" fill="#FFF4FC" />
      <path
        d="M38.5 35V38H26.5V35H24.5V38C24.5 39.1 25.4 40 26.5 40H38.5C39.6 40 40.5 39.1 40.5 38V35H38.5ZM27.5 29L28.91 30.41L31.5 27.83V36H33.5V27.83L36.09 30.41L37.5 29L32.5 24L27.5 29Z"
        fill="#BE2BBB"
      />
    </svg>
  );
};

export default UploadIcon;
